import React from 'react';

import { Header, tableBetHistoryStore } from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';

import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { HelpPopup } from '../../components/helpPopup';

import { BetHistoryWr } from '../betHistory';
import { SettingsContainer } from '../settingsContainer';
import logoSrc from '../../assets/images/loading/game-logo.png';

export const HeaderWr = observer(() => {
  const { setSelectedHistoryRow, selectedHistoryRow } = tableBetHistoryStore;
  const { currencySymbolOrCode } = userInfoStore;
  const { isSkipLobby } = gameConfigStore;

  return (
    <Header
      logoSrc={logoSrc}
      lobbyPath={isSkipLobby ? null : '/'}
      currencyCode={currencySymbolOrCode}
      selectedHistoryRow={selectedHistoryRow}
      setSelectedHistoryRow={setSelectedHistoryRow}
      gameControllerComponents={{
        [GameControllerTypes.Help]: <HelpPopup />,
        [GameControllerTypes.History]: <BetHistoryWr />,
        [GameControllerTypes.Settings]: <SettingsContainer />,
      }}
    />
  );
});
